export enum ProximityType {
  DistanceRadius = 'DistanceRadius',
  DriveTimePolygon = 'DriveTimePolygon',
}

export enum GroupRadiusEditLevel {
  IndividualLocation = 'IndividualLocation',
  Group = 'Group',
}
